import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-order-success',
  templateUrl: './dialog-order-success.component.html',
  styleUrls: ['./dialog-order-success.component.scss']
})
export class DialogOrderSuccessComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}
